import {
  formatPythonCode,
  formatJavaScriptCode,
  formatJavaCode,
  formatCCode,
  formatCSharpCode,
  formatGoCode,
  formatRustCode,
  formatPHPCode,
  formatRubyCode,
  formatSwiftCode,
  formatKotlinCode,
  formatScalaCode,
  formatSQLCode,
} from "./languageFormatters";
import { formatBasicIndentation } from "./baseFormatters";

/**
 * Main formatter router - routes code to appropriate formatter based on language
 * @param {string} code - Code to format
 * @param {string} language - Language identifier (e.g., "javascript", "python")
 * @returns {string} Formatted code
 */
export const formatWithPrettier = (code, language) => {
  try {
    console.log(`Formatting ${language} code...`);

    // JavaScript/TypeScript
    if (language === "javascript" || language === "typescript") {
      return formatJavaScriptCode(code);
    }
    // Python
    else if (language === "python") {
      return formatPythonCode(code);
    }
    // Java
    else if (language === "java") {
      return formatJavaCode(code);
    }
    // C/C++
    else if (language === "c" || language === "cpp") {
      return formatCCode(code);
    }
    // C#
    else if (language === "csharp") {
      return formatCSharpCode(code);
    }
    // Go
    else if (language === "go") {
      return formatGoCode(code);
    }
    // Rust
    else if (language === "rust") {
      return formatRustCode(code);
    }
    // PHP
    else if (language === "php") {
      return formatPHPCode(code);
    }
    // Ruby
    else if (language === "ruby") {
      return formatRubyCode(code);
    }
    // Swift
    else if (language === "swift") {
      return formatSwiftCode(code);
    }
    // Kotlin
    else if (language === "kotlin") {
      return formatKotlinCode(code);
    }
    // Scala
    else if (language === "scala") {
      return formatScalaCode(code);
    }
    // SQL
    else if (language === "sql") {
      return formatSQLCode(code);
    }
    // F# (similar to C#)
    else if (language === "fsharp") {
      return formatCSharpCode(code);
    }
    // Groovy (similar to Java)
    else if (language === "groovy") {
      return formatJavaCode(code);
    }
    // Objective-C (similar to C)
    else if (language === "objective-c") {
      return formatCCode(code);
    }
    // Dart (similar to JavaScript)
    else if (language === "dart") {
      return formatJavaScriptCode(code);
    }
    // Fallback: use basic indentation for other languages
    else {
      return formatBasicIndentation(code);
    }
  } catch (error) {
    console.warn(`Formatting failed for ${language}:`, error);
    // Fallback to basic formatting
    return formatBasicIndentation(code);
  }
};

